import { Injectable } from '@angular/core';
import { gql } from 'apollo-angular';

import { ApiQuery } from '../../../../common/model/api.query';
import { users } from '../model/user.fragments';
import { UserOutput } from '../model/user.output';

export interface FetchCoacheesWithoutCoachParams {
	readonly ids: string[];
}

@Injectable({ providedIn: 'root' })
export class FetchCoacheesWithoutCoachApiQuery extends ApiQuery<
	UserOutput[],
	FetchCoacheesWithoutCoachParams
> {
	client = 'iam';
	document = gql`
		query FetchCoacheesWithoutCoach($ids: [UUID]!) {
			fetchCoacheesWithoutCoach(ids: $ids) {
				...Users
			}
		}
		${users}
	`;
	method = 'fetchCoacheesWithoutCoach';
}
